import { render, staticRenderFns } from "./NotaExame-Admin.vue?vue&type=template&id=0588bcf3&"
import script from "./NotaExame-Admin.vue?vue&type=script&lang=js&"
export * from "./NotaExame-Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports